import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import PaymentStatus from "./Component/PaymentStatus";
import {
  AccessibilityPolicy,
  ComplaintsPolicy,
  DisclaimerPolicy,
  IntellectualPropertyPolicy,
  LegalNoticePolicy,
  OrdersPolicy,
  PaymentsPolicy,
  PrivacyChoicesPolicy,
  PromotionsPolicy,
  WarrantyPolicy,
} from "./Component/CommercePolicies";

function App() {
  return (
    <CartProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/orders" element={<OrdersPolicy />} />
          <Route path="/payments" element={<PaymentsPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/privacy-choices" element={<PrivacyChoicesPolicy />} />
          <Route path="/legal-notice" element={<LegalNoticePolicy />} />
          <Route
            path="/intellectual-property"
            element={<IntellectualPropertyPolicy />}
          />
          <Route path="/accessibility" element={<AccessibilityPolicy />} />
          <Route path="/disclaimer" element={<DisclaimerPolicy />} />
          <Route path="/payment" element={<PaymentStatus />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
